module.exports = __webpack_public_path__ + "devfont.woff?dd4fa0327b0d335d4311584a23850a97";